import { render, staticRenderFns } from "./screen-full.vue?vue&type=template&id=eb94201c&scoped=true&"
import script from "./screen-full.vue?vue&type=script&lang=js&"
export * from "./screen-full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb94201c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb94201c')) {
      api.createRecord('eb94201c', component.options)
    } else {
      api.reload('eb94201c', component.options)
    }
    module.hot.accept("./screen-full.vue?vue&type=template&id=eb94201c&scoped=true&", function () {
      api.rerender('eb94201c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/screen-full.vue"
export default component.exports